import { Modal } from "antd";
import { notify } from "@/shared/utils/notify";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import React from "react";
import { useSelector } from "react-redux";
import useAppDispatch from "../../../redux/hooks/useAppDispatch";
import { TableProperties } from "../../../shared/components/ui/Table/types";
import { selectproductWarehousesRefreshTable } from "../../../redux/selectors/productWarehouses.selectors";
import { warehousesService } from "../../../shared/services";
import { refreshTableAddressesUser } from "../../../redux";

const { confirm } = Modal;

export const useDeleteWerehouse = () => {
  const dispatch = useAppDispatch();
  const [tableProps, setTableProps] = React.useState<TableProperties>();
  const isproductWarehousesRefreshTable= useSelector(
    selectproductWarehousesRefreshTable
  );
  const showDeleteConfirm = (valId: number, val: string) => {
    confirm({
      title: `Estás seguro de borrar la bodega con el id: ${valId}`,
      icon: <ExclamationCircleOutlined />,
      content: `Una vez ejecutada esta acción no hay vuelta atrás, estás por borrar a "${val}", si deseas continuar dale click a "Borrar bodega" en caso tal solo oprime en "Cancelar".`,
      okText: "Borrar bodega",
      okType: "danger",
      cancelText: "Cancelar",
      async onOk() {
        await warehousesService.remove(valId)
        .then((_res) => {
              notify.success(`Se ha borrado con éxito la el producto de la bodega con id:${valId}`);
              tableProps?.refresh();
          })
          .catch((err) => {
            console.log({ err });
            notify.error(err.message);
          });
      },
      onCancel() {},
    });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    if (isproductWarehousesRefreshTable) {
      tableProps?.refresh();
      dispatch(refreshTableAddressesUser(false));
    }
  }, [isproductWarehousesRefreshTable]);
  
  return {
    tableProps,
    showDeleteConfirm,
    setTableProps,
  };
};
